import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tokens/")({
  beforeLoad: () => {
    throw redirect({ to: "/markets", replace: true });
  },
});
